// extracted by mini-css-extract-plugin
var _1 = "Button-PXu4f";
var _2 = "ButtonActive-scSIh";
export { _1 as "Button", _2 as "ButtonActive" }
